"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_AREA_PUBBLICA_REMOTES_BUCKET_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetAreaPubblicaBucket,
    skipImportingInCMS: false,
}, {
    tpdTracciaReclamoContainer: {
        __mfeName__: "tpdTracciaReclamoContainer",
        devClientPort: 7000,
        devServerPort: 7000,
    },
    tpdTracciaReclamoCardWidget: {
        __mfeName__: "tpdTracciaReclamoCardWidget",
        devClientPort: 7005,
        devServerPort: 7005,
    },
    tpdTracciaReclamoStatoModalWidget: {
        __mfeName__: "tpdTracciaReclamoStatoModalWidget",
        devClientPort: 7010,
        devServerPort: 7010,
    },
    tpdTracciaReclamoFiltroStatoWidget: {
        __mfeName__: "tpdTracciaReclamoFiltroStatoWidget",
        devClientPort: 7015,
        devServerPort: 7015,
    },
    tpdTracciaReclamoCardContainerWidget: {
        __mfeName__: "tpdTracciaReclamoCardContainerWidget",
        devClientPort: 7020,
        devServerPort: 7020,
    },
    tpdTracciaReclamoTabWidget: {
        __mfeName__: "tpdTracciaReclamoTabWidget",
        devClientPort: 7025,
        devServerPort: 7025,
    },
});
exports.WIDGET_AREA_PUBBLICA_REMOTES_BUCKET_SETTINGS = settings;
